import { api } from '@/lib/api'
import type { ProfileInfo, SubcategoryPayload, TaxonomyList } from './types'

export const coaApi = {
  list: () => api.get<TaxonomyList>('/api/taxonomy'),
  createSubcategory: (body: SubcategoryPayload) =>
    api.post<{ id?: number; message?: string }>('/api/taxonomy', body),
  updateSubcategory: (id: number, body: SubcategoryPayload) =>
    api.put<{ message?: string }>(`/api/taxonomy/${id}`, body),
  deleteSubcategory: (id: number) =>
    api.del<{ message?: string }>(`/api/taxonomy/${id}`),
  renameMainCategory: (statementType: string, oldName: string, newName: string) =>
    api.put<{ message?: string }>(
      `/api/taxonomy/main_category/${encodeURIComponent(statementType)}/${encodeURIComponent(oldName)}`,
      { newName },
    ),
  deleteMainCategory: (statementType: string, name: string) =>
    api.del<{ message?: string }>(
      `/api/taxonomy/main_category/${encodeURIComponent(statementType)}/${encodeURIComponent(name)}`,
    ),
  profile: () => api.get<ProfileInfo>('/api/profile'),
}
